<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="4" :sm="12">
            <a-form-item label="月份">
              <a-select placeholder="请选择" v-model="queryParam.month">
                <a-select-option value="01">1月</a-select-option>
                <a-select-option value="02">2月</a-select-option>
                <a-select-option value="03">3月</a-select-option>
                <a-select-option value="04">4月</a-select-option>
                <a-select-option value="05">5月</a-select-option>
                <a-select-option value="06">6月</a-select-option>
                <a-select-option value="07">7月</a-select-option>
                <a-select-option value="08">8月</a-select-option>
                <a-select-option value="09">9月</a-select-option>
                <a-select-option value="10">10月</a-select-option>
                <a-select-option value="11">11月</a-select-option>
                <a-select-option value="12">12月</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="4" :sm="10">
            <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;height:40px;">
        <span style="float:right; ">金额单位：万元</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="itemSlot" slot-scope="item">
          <span v-if="item.level===1">{{item.text}}</span>
          <span v-if="item.level===2" style="margin-left:0px;">{{item.text}}</span>
          <span v-if="item.level===3" style="margin-left:45px;">{{item.text}}</span>
        </template>
      </a-table>

    </div>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction, postAction } from '@/api/manage'
  import {getDictItemsFromCache} from '@/api/api'
  import { toDecimal } from '@/utils/util'

  export default {
    name: 'BizIntermediaryReport',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
    },
    data () {
      return {
        description: '中介监管报表',
        disableMixinCreated: true,
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'项目',
            className: 'column-text',
            scopedSlots: {customRender: 'itemSlot'}
          },
          {
            title:'总部',
            className: 'column-money',
            dataIndex: 'A03'
          },
          /*{
            title:'烟台',
            className: 'column-money',
            dataIndex: 'A03A08A06'
          },
          {
            title:'滨城',
            className: 'column-money',
            dataIndex: 'A03A08A08'
          },
          {
            title:'乐陵',
            className: 'column-money',
            dataIndex: 'A03A08A11'
          },*/
          {
            title:'临沂',
            className: 'column-money',
            dataIndex: 'A03A08A12'
          },
          /*{
            title:'枣庄',
            className: 'column-money',
            dataIndex: 'A03A08A07'
          },*/
          {
            title:'淄博',
            className: 'column-money',
            dataIndex: 'A03A08A03'
          },
          {
            title:'德州',
            className: 'column-money',
            dataIndex: 'A03A08A04'
          },
          {
            title:'青岛',
            className: 'column-money',
            dataIndex: 'A03A08A13'
          },
        ],
        url: {
          list: "/bms/regulatoryReport/intermediaryReport",
        },
      }
    },
    created() {
    },
    methods: {
      searchQuery(){
        if(this.queryParam.month){
          this.loadData()
        }
      },
      loadData() {
        this.loading = true;

        let year = new Date().getFullYear()
        let param = {year: year, month: this.queryParam.month}

        /*以invoice_time字段进行比较，即财务开票日期归属到不同月份*/
        postAction(this.url.list, param).then((res) => {
          if (res.success) {
            this.dataSource = this.transferData(res.result);
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },

      // 把后台返回数据进行格式转换
      transferData(resultData){
        if(!resultData){
          return;
        }

        // 总部寿险数据，顺序是确定的, level是报表中的级次，显示用
        let intermediaryData = [
          {text:'财产险保费：机动车交强险',level:1, insuranceTypeCode:'jdcjq', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},
          {text:'财产险保费：机动车商业险',level:1, insuranceTypeCode:'jdcsy', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},
          {text:'财产险保费：企财险',level:1, insuranceTypeCode:'qcx', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},
          {text:'财产险保费：责任险',level:1, insuranceTypeCode:'zrx', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},
          {text:'财产险保费：工程险',level:1, insuranceTypeCode:'gcx', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},
          {text:'财产险保费：其他险',level:1, insuranceTypeCode:'cxqt', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},
          {text:'财产险保费合计：',level:3, insuranceTypeCode:'cxhj', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},

          {text:'人身险保费：寿险期交新单',level:1, insuranceTypeCode:'sxqjxd', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},
          {text:'人身险保费：寿险期交续期',level:1, insuranceTypeCode:'sxqjxq', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},
          {text:'人身险保费：寿险趸交',level:1, insuranceTypeCode:'sxdj', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},
          {text:'人身险保费：意外伤害险',level:1, insuranceTypeCode:'ywx', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},
          {text:'人身险保费：健康险',level:1, insuranceTypeCode:'jkx', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},
          {text:'人身险保费合计：',level:3, insuranceTypeCode:'rsxhj', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},

          {text:'咨询业务收入:',level:1, insuranceTypeCode:'zxywsr', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},
          {text:'总佣金收入:',level:1, insuranceTypeCode:'yjsr', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0},
          {text:'税金:',level:1, insuranceTypeCode:'sj', A03:0.00, A03A08A06:0.00,A03A08A08:0.00,A03A08A11:0.00, A03A08A12:0.00,A03A08A07:0.00,A03A08A03:0.00,A03A08A04:0.00, A03A08A13:0.0}];

        // 赋值结果集
        for(let i=0; i<intermediaryData.length; i++){
          let orgMoneyArray = resultData[intermediaryData[i].insuranceTypeCode] // 数组
          if(orgMoneyArray){
            for(let j=0; j<orgMoneyArray.length; j++){
              intermediaryData[i][orgMoneyArray[j].orgCode] = orgMoneyArray[j].money
            }
          }
        }

        //计算求和, 根据报表公式直接求和
        //7＝1+2+3+4+5+6
        for(let i=0; i<6; i++){
          intermediaryData[6].A03 = toDecimal(intermediaryData[6].A03 + intermediaryData[i].A03)
          intermediaryData[6].A03A08A06 = toDecimal(intermediaryData[6].A03A08A06 + intermediaryData[i].A03A08A06)
          intermediaryData[6].A03A08A08 = toDecimal(intermediaryData[6].A03A08A08 + intermediaryData[i].A03A08A08)
          intermediaryData[6].A03A08A11 = toDecimal(intermediaryData[6].A03A08A11 + intermediaryData[i].A03A08A11)
          intermediaryData[6].A03A08A12 = toDecimal(intermediaryData[6].A03A08A12 + intermediaryData[i].A03A08A12)
          intermediaryData[6].A03A08A07 = toDecimal(intermediaryData[6].A03A08A07 + intermediaryData[i].A03A08A07)
          intermediaryData[6].A03A08A03 = toDecimal(intermediaryData[6].A03A08A03 + intermediaryData[i].A03A08A03)
          intermediaryData[6].A03A08A04 = toDecimal(intermediaryData[6].A03A08A04 + intermediaryData[i].A03A08A04)
          intermediaryData[6].A03A08A13 = toDecimal(intermediaryData[6].A03A08A13 + intermediaryData[i].A03A08A13)
        }

        //13＝8+9+10+11+12
        for(let i=7; i<12; i++){
          intermediaryData[12].A03 = toDecimal(intermediaryData[12].A03 + intermediaryData[i].A03)
          intermediaryData[12].A03A08A06 = toDecimal(intermediaryData[12].A03A08A06 + intermediaryData[i].A03A08A06)
          intermediaryData[12].A03A08A08 = toDecimal(intermediaryData[12].A03A08A08 + intermediaryData[i].A03A08A08)
          intermediaryData[12].A03A08A11 = toDecimal(intermediaryData[12].A03A08A11 + intermediaryData[i].A03A08A11)
          intermediaryData[12].A03A08A12 = toDecimal(intermediaryData[12].A03A08A12 + intermediaryData[i].A03A08A12)
          intermediaryData[12].A03A08A07 = toDecimal(intermediaryData[12].A03A08A07 + intermediaryData[i].A03A08A07)
          intermediaryData[12].A03A08A03 = toDecimal(intermediaryData[12].A03A08A03 + intermediaryData[i].A03A08A03)
          intermediaryData[12].A03A08A04 = toDecimal(intermediaryData[12].A03A08A04 + intermediaryData[i].A03A08A04)
          intermediaryData[12].A03A08A13 = toDecimal(intermediaryData[12].A03A08A13 + intermediaryData[i].A03A08A13)
        }

        return intermediaryData;
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>
